// import React, { useEffect } from "react";
import Hero from "../components/Hero";
import CoursesList from "../components/CoursesList";
import CategoryList from "../components/CategoriesList";
import { useEffect } from "react";
const HomePage = () => {
  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND}/drop`, {
      method: "GET",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        console.log(res);
        res.json();
      })
      .then((res) => console.log(res));
    // Store.addNotification({
    //   title: "Wonderful!",
    //   message: "teodosii@react-notifications-component",
    //   type: "success",
    //   insert: "top",
    //   container: "top-right",
    //   animationIn: ["animate__animated", "animate__fadeIn"],
    //   animationOut: ["animate__animated", "animate__fadeOut"],
    //   dismiss: {
    //     duration: 5000,
    //     onScreen: true,
    //   },
    // });
  }, []);
  return (
    <div className="holder">
      <Hero />
      <CoursesList />
      <CategoryList />
    </div>
  );
};

export default HomePage;
